import { render, staticRenderFns } from "./SysTypeCatManager.vue?vue&type=template&id=cf35b126&scoped=true&"
import script from "./SysTypeCatManager.vue?vue&type=script&lang=js&"
export * from "./SysTypeCatManager.vue?vue&type=script&lang=js&"
import style0 from "./SysTypeCatManager.vue?vue&type=style&index=0&id=cf35b126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf35b126",
  null
  
)

export default component.exports